<template>
   <div class="">
    <b-badge :variant="data.isSupplyAccepted ? 'success' : data.isSupplyRejected ? 'danger' : 'light'" >
        {{data.isSupplyAccepted ? 'Accepted' : data.isSupplyRejected ? 'Rejected' : "-"}}
    </b-badge>
    <b-badge variant="light" @click="seeReason" v-if="data.isSupplyRejected" class="cursor-pointer">
         {{$t('text.clickButtons.seeReason')}}
    </b-badge>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {
          title: "sblhsbglhbsghbslbgjsbjg"
      },
    };
  },
  mounted() {
      
  },
  methods: {
    acceptSupply() {
        const deleteConfirm = window.confirm("Are you sure you want to accept this supply?");
        if(deleteConfirm){
            this.axios.post(`${configObject.apiBaseUrl}​/NonWetProductSupply/AcceptSupply/${this.data.branchId}/${this.data.id}`, {},  configObject.authConfig())
                .then(() => {                
                    this.$toast.open({
                        message: "Successfully accepted  supply",
                        type: 'success',
                        duration: 5000
                    });
                    this.$eventHub.$emit("renderNonWetProductSupplies")
                }).catch(error => {       
                  this.$toast.open({
                      message: error.response.data.message ,
                      type: 'error',
                      duration: 5000
                  });
              });
        }
    },
    seeReason() {
     this.$eventHub.$emit("_rejectSupplyReason", this.data)
    }
  },
};

</script>